import SEO from "../../components/SEO";
import AutoScrollableImage from "./AutoScrollableImage";
import BusinessBenefits from "./BusinessBenefits";
import ExploreFunding from "./ExploreFunding";
import LoanEligibilityBanner from "./LoanEligibilityBanner";
import Partners from "./Partners";
import QuestionAnswer from "./QuestionAnswer";
import Testimonials from "./Testimonials";

const Home = ({ setTabIndex }) => {
  return (
    <>
      <SEO
        title="MSME Business Loans Delhi NCR | Unsecured & CGTMSE"
        description="Dequitec offers fast, reliable business loan consulting with expert advice, tailored solutions, and easy eligibility checks to help your business grow."
        canonical="https://www.dequitec.com/"
      />
      <AutoScrollableImage setTabIndex={setTabIndex} />
      <LoanEligibilityBanner />
      <ExploreFunding />
      <BusinessBenefits />
      <Partners />
      <Testimonials />
      <QuestionAnswer />
    </>
  );
};

export default Home;
